module.exports = __webpack_public_path__ + "img/wa_logo.22e41ea3.png";